import router from "@/router"
import * as store from '@/store'
export const saveTokenToSession = (token: string) => {
  (window as any).sessionStorage.setItem('token', token)
}
export const getTokenBySession = () => (window as any).sessionStorage.getItem('token')
export const removeTokenBySession = () => {
  (window as any).sessionStorage.removeItem('token')
}

export const logout = () => {
  removeTokenBySession()
  store.commit('user', {})
  router.push('/login')
}